var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VTableLocal',{attrs:{"items":_vm.displayedItems,"showRowIcon":true,"itemActions":_vm.getItemActions,"centerColumns":"['action']","headers":_vm.tableHeaders,"disablePagination":true},on:{"iconAction":_vm.onClickAction}})}
var staticRenderFns = []

export { render, staticRenderFns }